var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentAcceptance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x94\x8D-Product-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_payment_24_filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8-Color",
    d: "M20.4887 6.49471L20.4893 11.7758C20.4893 13.2383 19.3476 14.4342 17.9068 14.5208L17.7393 14.5258H3.26146C1.79893 14.5258 0.603058 13.3841 0.516481 11.9433L0.511462 11.7758L0.510742 6.49471H20.4887ZM16.7533 10H14.2533L14.1515 10.0068C13.7855 10.0565 13.5033 10.3703 13.5033 10.75C13.5033 11.1297 13.7855 11.4435 14.1515 11.4932L14.2533 11.5H16.7533L16.8551 11.4932C17.2212 11.4435 17.5033 11.1297 17.5033 10.75C17.5033 10.3703 17.2212 10.0565 16.8551 10.0068L16.7533 10ZM17.7393 0.520706C19.2018 0.520706 20.3977 1.66241 20.4843 3.10318L20.4893 3.27071L20.4887 4.99471H0.510742L0.511462 3.27071C0.511462 1.80817 1.65317 0.612302 3.09394 0.525725L3.26146 0.520706H17.7393Z",
    fill: "#304FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAcceptance);
export default __webpack_public_path__ + "static/media/paymentAcceptance.8a006035b840e502bb3e1f40575ee4eb.svg";
export { ForwardRef as ReactComponent };